export default {"src":"/_next/static/media/IdeaIcon.ed8239ac.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};